module.exports = __webpack_public_path__ + "media/images/nereport/icon_nega2-e37e69e2940acb16bc457c2586975200.svg";